export default "/packs/images/Gobi~e78e72a44596c6e3c3613e3ca58552e4.jpg";